import React, { useCallback } from 'react';
import { Pane, Flex } from '@leverege/ui-elements';
import { LabelText, DetailUtil, Formatters } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import Model from "../model/GeoDistanceAggTextViewModel.js";
import { AggClickActionFactory, AggModelFactory } from "../Factory.js";
import { buildVariant } from "../../util/index.js";
import GeoDistanceAggTextItem from "./GeoDistanceAggTextItem.js";
import { FilterSourcesModel } from "../../../../filters/index.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('molten.dataViewers.aggregations.GeoDistanceAggTextView');
export default function GeoDistanceAggTextView(props) {
  const {
    value,
    data,
    className,
    vertical,
    aggModel,
    queryModel,
    context,
    hasHeaders = true
  } = props;
  const {
    clientProps: {
      objectType,
      delegate,
      filters
    }
  } = context;
  let {
    variant
  } = props;
  const metadatas = FilterSourcesModel.getMetadata(filters);
  const filterBarFilterMetadata = metadatas?.filterBar?.filter;
  variant = Model.getVariant(value) || variant;
  const onClickBucket = useCallback(({
    data,
    value
  }) => {
    const action = AggClickActionFactory.get(value ? queryModel : 'aggregation.noFilter');
    action?.onClick(data, {
      ...context,
      queryModel
    });
  }, [queryModel, context]);
  if (!data) {
    return null;
  }
  const AggModel = AggModelFactory.get(aggModel);
  const hLStyle = DetailUtil.getStyle(value?.header?.label);
  const vLStyle = {
    ...DetailUtil.getStyle(value?.value?.label),
    whiteSpace: 'nowrap'
  };
  const vTStyle = DetailUtil.getStyle(value?.value?.text);
  let subLabel = Model.getHeaderSubLabelVisible(value) ? Formatters.format(aggModel.origin, Model.getHeaderSubLabelFormatter(value)) : null;
  if (Array.isArray(subLabel)) {
    const [lat, lng] = subLabel;
    subLabel = lng ? `${lat}, ${lng}` : lat;
  }
  let headerLabel = Model.getHeaderLabel(value);
  if (subLabel) {
    headerLabel = `${headerLabel ? `${headerLabel} ` : ''}(${subLabel})`;
  }
  return /*#__PURE__*/_jsx(Pane, {
    variant: buildVariant(variant, 'Item'),
    className: className,
    children: /*#__PURE__*/_jsxs(Flex, {
      variant: buildVariant(variant, 'ContainerFlex', 'colMStart'),
      children: [hasHeaders && /*#__PURE__*/_jsx(LabelText, {
        variant: buildVariant(variant, 'Title'),
        style: {
          ...hLStyle,
          visibility: headerLabel ? 'visible' : 'hidden'
        },
        children: headerLabel || 'M'
      }), /*#__PURE__*/_jsx(Flex, {
        variant: vertical ? 'aggBucketVertical' : 'aggBucketHorizontal',
        style: {
          flexWrap: vertical ? 'wrap' : undefined,
          width: vertical ? '100%' : undefined
        },
        children: data.buckets.length > 0 ? data.buckets.map(bucket => {
          const key = AggModel.formatBucketKey(bucket, aggModel, {
            trueValue: Model.getTrueValue(value),
            falseValue: Model.getFalseValue(value),
            objectType,
            delegate
          });
          const name = AggModel.formatBucketName?.(bucket, aggModel, {
            trueValue: Model.getTrueValue(value),
            falseValue: Model.getFalseValue(value),
            objectType,
            delegate
          }) || key;
          return /*#__PURE__*/_jsx(GeoDistanceAggTextItem, {
            context: context,
            delegate: delegate,
            objectType: objectType,
            queryModel: queryModel,
            filter: filterBarFilterMetadata,
            bucket: bucket,
            bucketName: name,
            onClickBucket: onClickBucket,
            value: value,
            variant: variant,
            vLStyle: vLStyle,
            vTStyle: vTStyle
          }, key);
        }) : /*#__PURE__*/_jsx(LabelText, {
          style: vLStyle,
          children: t('noData')
        })
      })]
    })
  });
}